import React, { useId } from 'react';
import FormField from '../FormField/FormField';

const UserSignupForm = ({
  activeForm,
  formData,
  handleChange,
  handleSubmit,
  toggleForm,
  handleBlur,
  handleFocus,
}) => {
  const generatedId = useId();
  const fields = [
    {
      label: 'Ваш e-mail',
      type: 'email',
      name: 'email',
      placeholder: 'Введите ваш email',
    },
    {
      label: 'Ваш логин',
      type: 'text',
      name: 'login',
      placeholder: 'Введите ваш логин',
    },
    {
      label: 'Телефон',
      type: 'tel',
      name: 'phone',
      placeholder: '+7(___) ___-__-__',
    },
    {
      label: 'Пароль',
      type: 'password',
      name: 'password',
      placeholder: 'Введите пароль',
    },
    {
      label: 'Подтвердите пароль',
      type: 'password',
      name: 'confirmPassword',
      placeholder: 'Повторите пароль',
    },
  ];

  return (
    <div
      className={`auth-forms__form  ${activeForm === 'register' ? 'show' : ''
        } auth-forms__form_register`}
    >
      <h2 className='auth-forms__title'>Регистрация</h2>
      <form
        onSubmit={handleSubmit}
        className='auth-forms__form-container'
        autoComplete='off'
      >
        {fields.map(({ label, type, name, placeholder }) => (
          <FormField
            key={name + generatedId}
            label={label}
            type={type}
            name={name}
            value={formData[name] || ''}
            onChange={handleChange}
            placeholder={placeholder}
            error={formData.errors?.[name]}
            onBlur={handleBlur}
            onFocus={handleFocus}
          />
        ))}

        <button
          disabled={
            !formData.email || !formData.password || !formData.confirmPassword
          }
          type='submit'
          className='auth-forms__button'
        >
          Зарегистрироваться
        </button>
      </form>

      <p className='auth-forms__text'>
        Уже есть аккаунт?{' '}
        <span
          className='auth-forms__link'
          onClick={() => toggleForm('sign-in')}
        >
          Войти
        </span>
      </p>
    </div>
  );
};

export default UserSignupForm;
